import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
    state:{//要设置的全局访问的全局对象
        video:true
    },
    getters: {//实时监听state值的变化(最新)
        getvideo(state) {
            return state.video
        }
    },
    mutations: {
        getVideo(state,data) {
            state.video = data;
        }
    }

})


// WEBPACK FOOTER //
// ./src/store/index.js